// extracted by mini-css-extract-plugin
module.exports = {"products":"sx-z","misad":"tx-z","oosMessaging":"ux-z"};